var localeSpecificMinicart = {

  elements: {},
  root: '',

  init: function() {
    if(
      typeof Shopify == 'undefined' ||
      typeof Shopify.routes == 'undefined' ||
      typeof Shopify.routes.root == 'undefined'
    ) {
      return;
    }

    this.root = Shopify.routes.root;

    if(this.root == '/') {
      return;
    }

    if(typeof BoosterTheme == 'undefined') {
      return;
    }

    if(!this.getElements()) {
      return;
    }

    this.setEvents();
  },

  getElements: function() {
    this.elements.minicartHolders = jQuery('.minicart__holder');
    if(!this.elements.minicartHolders.length) {
      return false;
    }

    return true;
  },

  setEvents: function() {
    var _self = this;

    BoosterTheme.cart.events.on('booster:content:update', function() {
      _self.updateMinicart();
    });
  },

  updateMinicart: async function() {
    var tempElement = document.createElement('div');
    var response = await (
      await fetch(
        this.root + '?section_id=api__minicart',
        {
          headers: {
            Pragma: "no-cache",
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Expires: 0
          }
        }
      )
    ).text();

    tempElement.innerHTML = response;
    
    var responseData = JSON.parse(tempElement.innerText);

    if(typeof responseData.html == 'undefined') {
      return;
    }

    this.updateMinicartMarkup(responseData.html);
  },

  updateMinicartMarkup: function(markup) {
    var wrapper = jQuery('<div data-product-list data-last-update="' + Date.now() + '"> ' + markup + ' </div>');

    this.elements.minicartHolders.empty();
    this.elements.minicartHolders.append(wrapper);
  }

};

function initLocaleSpecificMinicart() {
  if(typeof BoosterTheme == 'undefined') {
    setTimeout(initLocaleSpecificMinicart, 200);

    return;
  }

  localeSpecificMinicart.init();
}

jQuery(document).ready(function() {
  initLocaleSpecificMinicart();
});
